import "./App.css";

function App() {
  return (
    <div className="container">
      <h1 style={{ color: "white" }}>Privacy Policy</h1>
      <p style={{ color: "white" }}>
        At Pin Jump, we respect your privacy and are committed to protecting
        your personal information. This Privacy Policy outlines how we collect,
        use, and disclose information when you use our mobile application, Pin
        Jump.
      </p>
      <p style={{ color: "white" }}>What information do we collect?</p>
      <p style={{ color: "white" }}>
        When you use Pin Jump, we may collect information about your device,
        including your device type, operating system, and unique device
        identifiers. We may also collect information about how you use the
        application, such as the pages and features you access, the actions you
        take, and the time and date of your visits.
      </p>
      <p style={{ color: "white" }}>
        We may also collect information that you provide to us, such as your
        name and email address, if you choose to sign up for our mailing list or
        contact us through our website.
      </p>
      <p style={{ color: "white" }}>How do we use your information?</p>
      <p style={{ color: "white" }}>
        We may use the information we collect to:
      </p>
      <p style={{ color: "white" }}>
        Provide and maintain Pin Jump Improve Pin Jump and our services Respond
        to your requests and inquiries Send you marketing communications, if you
        have opted in to receive them Monitor and analyze usage and trends We
        may also share your information with third-party service providers that
        assist us in providing Pin Jump and our services. These providers may
        have access to your information only to perform tasks on our behalf and
        are obligated not to disclose or use it for any other purpose.
      </p>
      <p style={{ color: "white" }}>
        We may also disclose your information if required to do so by law or if
        we believe that such action is necessary to comply with a legal
        obligation, protect and defend our rights or property, prevent fraud, or
        protect the safety of our users.
      </p>
      <p style={{ color: "white" }}>How do we protect your information?</p>
      <p style={{ color: "white" }}>
        We take reasonable measures to protect your information from
        unauthorized access, alteration, disclosure, or destruction. However, no
        method of transmission over the internet or method of electronic storage
        is 100% secure, and we cannot guarantee the absolute security of your
        information.
      </p>
      <p style={{ color: "white" }}>Children's Privacy</p>
      <p style={{ color: "white" }}>
        Pin Jump does not knowingly collect or solicit personal information from
        children under the age of 13. If you are a parent or guardian and
        believe that your child has provided us with personal information
        without your consent, please contact us so that we can remove the
        information.
      </p>
      <p style={{ color: "white" }}>Changes to this Privacy Policy</p>
      <p style={{ color: "white" }}>
        We may update this Privacy Policy from time to time, and we encourage
        you to review it periodically. Your continued use of Pin Jump after we
        post any modifications to the Privacy Policy on this page will
        constitute your acknowledgment of the modifications and your consent to
        abide and be bound by the modified Privacy Policy.
      </p>
      <p style={{ color: "white" }}>Contact Us</p>
      <p style={{ color: "white" }}>
        If you have any questions or comments about this Privacy Policy, please
        contact us at esmachta@gmail.com.
      </p>
    </div>
  );
}

export default App;
